/**
 * Story screen assets — imported from appAssets so CRA bundles them (no /public copy needed).
 */
import introIpad from "../../../appAssets/intro_ipad.png";
import introIphone from "../../../appAssets/intro_iphone.png";
import raysBg from "../../../appAssets/rays.png";
import shrinkedProgressBar from "../../../appAssets/shrinkedProgressBar.png";
import menuIcon from "../../../appAssets/svg/menuIcon.svg";
import keyboardIcon from "../../../appAssets/svg/keyboardIcon.svg";
import objectTapSound from "../../../appAssets/sounds/select_object.mp3";

import journeyIcon from "../../../appAssets/jsons/journeyIcon.json";
import replayIcon from "../../../appAssets/jsons/replayIcon.json";
import playerPlayBtn from "../../../appAssets/jsons/playerPlayBtn.json";
import playerPauseBtn from "../../../appAssets/jsons/playerPauseBtn.json";
import gemStarIcon from "../../../appAssets/jsons/gem_star.json";
import bouncyBag from "../../../appAssets/jsons/bouncyBag.json";
import bouncyBox from "../../../appAssets/jsons/bouncyBox.json";
import bouncyFrame from "../../../appAssets/jsons/bouncyFrame.json";
import floatingBallon from "../../../appAssets/jsons/floatingBallon.json";
import plannerIcon from "../../../appAssets/jsons/plannerIcon.json";
import hamburger from "../../../appAssets/jsons/hamburger.json";
import logoutIcon from "../../../appAssets/jsons/logoutIcon.json";

/** @deprecated Assets are bundled via imports; kept for API compatibility. */
export const STORY_ASSETS_BASE = "";

export const storyAssets = {
  introIpad,
  introIphone,
  raysBg,
  shrinkedProgressBar,
  menuIcon,
  keyboardIcon,
  objectTapSound,

  lottie: {
    journeyIcon,
    replayIcon,
    playerPlayBtn,
    playerPauseBtn,
    gemStarIcon,
    bouncyBag,
    bouncyBox,
    bouncyFrame,
    floatingBallon,
    plannerIcon,
    hamburger,
    logoutIcon,
  },
};
